// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__24yRZ","modal":"Modal_modal__L1rue","slide-down":"Modal_slide-down__dx1W3"};